import { addDays, format } from "date-fns";

export function parseTimesToDate(time) {
	const today = new Date();

	const parsedTime = time.split(":");
	today.setHours(parsedTime[0]);
	today.setMinutes(parsedTime[1]);

	return today;
}

export function defineItemColor({ item }) {
	const {
		vehicleTypeId,
		vehicleBodyId,
		loadingTime,
		unloadingTime,
		weight,
		length,
		loadingDate,
		isFull,
		isLTL,
	} = item;

	const defaultColor = "#D6EEFF";
	const aiRulesColor = "#c8ceff";

	const isFtlFound = isFull;
	const isLtlFound = isLTL;
	const isVehicleTypeIdFound =
		vehicleTypeId?.length || weight > 10 || length > 10;
	const isVehicleBodyIdFound =
		vehicleBodyId?.length || weight > 10 || length > 10;
	const isFoundLoadingTime = !!loadingTime;
	const isFoundUnloadingTime = !!unloadingTime;
	const isWeightFound = weight > 0 || isFull;
	const isLengthFound = length > 0 || isFull;
	const isFoundLoadingData = !!loadingDate;

	return {
		ftl: isFtlFound || isLtlFound ? defaultColor : aiRulesColor,
		vehicleTypeId: isVehicleTypeIdFound ? defaultColor : aiRulesColor,
		vehicleBodyId: isVehicleBodyIdFound ? defaultColor : aiRulesColor,
		loadingTime: isFoundLoadingTime ? defaultColor : aiRulesColor,
		unloadingTime: isFoundUnloadingTime ? defaultColor : aiRulesColor,
		weight: isWeightFound ? defaultColor : aiRulesColor,
		length: isLengthFound ? defaultColor : aiRulesColor,
		loadingDate: isFoundLoadingData ? defaultColor : aiRulesColor,
	};
}

export function handleLoadingDate({ rule }) {
	const today = new Date();

	switch (rule) {
		case "current-day":
			return format(today, "yyyy-MM-dd");
		case "next-day":
			return format(addDays(today, 1), "yyyy-MM-dd");
		case "range-today-1":
			return `${format(today, "yyyy-MM-dd")}:${format(
				addDays(today, 1),
				"yyyy-MM-dd"
			)}`;
		case "range-today-2":
			return `${format(today, "yyyy-MM-dd")}:${format(
				addDays(today, 2),
				"yyyy-MM-dd"
			)}`;
		case "range-tomorrow-1":
			return `${format(addDays(today, 1), "yyyy-MM-dd")}:${format(
				addDays(today, 2),
				"yyyy-MM-dd"
			)}`;
		case "range-tomorrow-2":
			return `${format(addDays(today, 1), "yyyy-MM-dd")}:${format(
				addDays(today, 3),
				"yyyy-MM-dd"
			)}`;
		default:
			return "";
	}
}
